import React from 'react';
import { observer } from 'mobx-react';
import { Formik } from 'formik';

import { CentreModal } from 'src/components/Modals';

import { BlockingForm } from './BlockingForm';
import { useProfileWidgetStore } from './StoreProvider';

import 'src/components/Modals/modals.style.css';

export const BlockingModal = observer(() => {
  const store = useProfileWidgetStore();

  return (
    <Formik initialValues={{ reason: null }} onSubmit={store.onSubmitBlock} validateOnMount validateOnBlur>
      <CentreModal isShow={store.blockingModal.isVisible} title="Заблокировать" onHide={store.blockingModal.hide}>
        <BlockingForm />
      </CentreModal>
    </Formik>
  );
});
